// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3tBL1","unreadBadge":"styles_unreadBadge__3Fr9v","modalContent":"styles_modalContent__3aTrH","modal":"styles_modal__30bzw"};